// local
import { TRENDS } from './constants.js';
// packages
import { get } from 'svelte/store';
import { createFeed } from './stores.js';

import {
  renderSvelteComponent,
  findSvelteComponentContainer,
} from './utils/render.js';
import { derived } from 'svelte/store';

// components
import BalanceOfPower from './components/BalanceOfPower.svelte';

async function main() {
  const trendsFeed = await createFeed(TRENDS);

  // find the container
  const element = findSvelteComponentContainer('#ca-us-house-balance-of-power');

  if (element) {
    // get the id
    const elementId = element.id;
    // filter trends feed to get the ca u.s. house data
    let caUsHouseTrends = derived(
      trendsFeed,
      ($feed) => $feed.califonia_us_house
    );
    // render
    renderSvelteComponent(
      BalanceOfPower,
      /** @type {HTMLElement} */
      element,
      {
        feed: caUsHouseTrends,
      }
    );
  }
}

main().catch(console.error);
